/**
 * Options for decoding Structured Field values
 *
 * @group Structured Field
 *
 * @beta
 */
export type SfDecodeOptions = {
	/**
	 * Use JS Symbol to represent token values
	 */
	useSymbol?: boolean;
};
